// src/features/developer/components/CodeEditor.tsx
import React from 'react';
import Editor, { OnChange } from '@monaco-editor/react';
import { useTheme, CircularProgress, Box } from '@mui/material';

interface CodeEditorProps {
    value: string;
    onChange?: OnChange;
    language: string;
    readOnly?: boolean;
    placeholder?: string;
}

const CodeEditor: React.FC<CodeEditorProps> = ({ value, onChange, language, readOnly = false, placeholder }) => {
    const theme = useTheme();
    const editorTheme = theme.palette.mode === 'dark' ? 'vs-dark' : 'vs';

    const handleEditorDidMount = (editor: any, monaco: any) => {
        // Optional: Add custom initialization here if needed
    };

    return (
        <Box sx={{ height: '500px', width: '100%', border: `1px solid ${theme.palette.divider}`, borderRadius: 1, position: 'relative' }}>
            {!value && placeholder && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: '15px',
                        left: '60px',
                        color: 'text.disabled',
                        zIndex: 1,
                        pointerEvents: 'none',
                    }}
                >
                    {placeholder}
                </Box>
            )}
            <Editor
                height="100%"
                language={language}
                value={value}
                onChange={onChange}
                theme={editorTheme}
                onMount={handleEditorDidMount}
                loading={<CircularProgress />}
                options={{
                    readOnly,
                    minimap: { enabled: false },
                    scrollBeyondLastLine: false,
                    automaticLayout: true,
                    wordWrap: 'on',
                    contextmenu: true,
                    fontSize: 14,
                }}
            />
        </Box>
    );
};

export default CodeEditor;